import { Element, Node, Text } from "slate";

export function simpleSerialize(nodes: Node[]): string {
  return nodes.map((node) => serializeNode(node)).join("\n");
}

const serializeNode = (node: Node): string => {
  if (Element.isElement(node)) {
    // Handle mentions
    if (node.type === "mention") {
      return `@id${node.id}`;
    }

    // For block-level elements (paragraphs, etc.), join children without separator
    // The newline separator is added between blocks in the main function
    if (node.children) {
      return node.children.map(serializeNode).join("");
    }
  }

  if (Text.isText(node)) {
    // Preserve tabs and other whitespace characters
    return node.text;
  }

  return "";
};
